// utils/formatDate.js
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  // Format the time
  let hours = date.getHours();
  let minutes = date.getMinutes().toString().padStart(2, "0");
  let ampm = "AM";

  if (hours >= 12) {
    ampm = "PM";
    if (hours > 12) hours -= 12; // Convert to 12-hour format
  }

  if (hours === 0) hours = 12; // Midnight case
  if (hours === 12) ampm = "PM"; // Noon case

  // Format the full date and time string
  return `${day} ${month}, ${year} ${hours}:${minutes} ${ampm}`;
};

export function formatDateWithTime(date) {
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatDateOnly(date) {
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
export function formatFollowUp(followUpDate, followUpTime) {
  if (!followUpDate || !followUpTime) return "";

  const date = new Date(followUpDate);
  if (isNaN(date.getTime())) return "";

  const [hStr, mStr] = followUpTime.toString().split(":");
  const hours = parseInt(hStr, 10);
  const minutes = parseInt(mStr, 10);
  if (isNaN(hours) || isNaN(minutes)) return "";

  date.setHours(hours, minutes);

  const day = ("0" + date.getDate()).slice(-2);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  let hrs = date.getHours();
  const ampm = hrs >= 12 ? "pm" : "am";
  hrs = hrs % 12 || 12;
  const minsPadded = ("0" + date.getMinutes()).slice(-2);

  return `${day} ${month} ${year} ${hrs}:${minsPadded} ${ampm}`;
}
